/**
 * External Imports
 */
import styled from 'styled-components';

/**
 * Nexus Imports
 */
import { NeuIcon } from '@neutron/react';

export const Card = styled.div`
  display: flex;
  padding: 0.5rem 0;
  position: relative;
`;

export const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 0 100%;
`;

export const CardHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const CardHeader = styled.p`
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px;
  letter-spacing: 0px;
  text-align: left;
  color: #124e7f;
  overflow-wrap: anywhere;
`;

export const CardContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  padding-right: 0.65rem;
`;

export const StatusContainer = styled.div`
  display: flex;
  margin-top: 10px;
  margin-left: -3px;
`;

export const CardContent = styled.div`
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 0px;
  text-align: left;
`;

export const CardHeaderRight = styled.p`
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 0px;
  text-align: right;
  margin-left: auto;
`;

export const CardSubHeader = styled.div`
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px;
  letter-spacing: 0px;
  text-align: left;
`;

export const ChevronRightIcon = styled(NeuIcon)`
  color: #124e7f;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0px;
  margin-left: auto;
  position: absolute;
  right: -12px;
  top: 40%;
`;

export const StatusIconCompleted = styled(NeuIcon)`
  margin-right: 0.5rem;
  color: #548a2c;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0px;
`;

export const StatusIconOpened = styled(NeuIcon)`
  margin-right: 0.5rem;
  color: #3282ba;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0px;
`;
